module.exports = __webpack_public_path__ + "static/media/ckn_platillo_edicion.9f4186bd.jpg";